import { Modal, ModalTabs, PDFRenderer } from "components";
import { useAppSearch, useCurrentUser } from "_graphql/cache/auth";

import config from "config";
import { useState } from "react";

const tabs: any[] = [
  {
    name: "Offer Slip",
    href: "Placing",
  },
  {
    name: "Cover Note",
    href: "Cover",
  },
  {
    name: "Debit Note",
    href: "Debit",
  },
  {
    name: "Contract Changes",
    href: "Contract",
  },
];

export default function ViewOfferSlipContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("Placing");
  const searchParams = useAppSearch();
  const currentUser = useCurrentUser();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      hidePadding
      size="6xl"
      title="Placing Slip"
      description={"Details of placing slip are shown below"}
    >
      <ModalTabs
        tabs={tabs}
        setOrderStatus={setOrderStatus}
        orderStatus={orderStatus}
      />
      {orderStatus === "Placing" && (
        <PDFRenderer
          url={`${config.asset.uri}endorsement_placing_slip/${btoa(
            JSON.stringify({
              offer_endorsement_id: searchParams?.id,
              doc_number: -1,
              type: "Cover",
              hasEndOfferSlip: true,
              emp_id: currentUser?.employee?.employee_id || "",
            })
          )}`}
        />
      )}
      {orderStatus === "Cover" && (
        <PDFRenderer
          url={`${config.asset.uri}contract_changes/${btoa(
            JSON.stringify({
              offer_endorsement_id: searchParams?.id,
              type: "Cover",
              doc_number: -1,
              emp_id: currentUser?.employee?.employee_id || "",
            })
          )}`}
        />
      )}
      {orderStatus === "Debit" && (
        <PDFRenderer
          url={`${config.asset.uri}endorsement_debit_note/${btoa(
            JSON.stringify({
              offer_endorsement_id: searchParams?.id,
              doc_number: -1,
              emp_id: currentUser?.employee?.employee_id || "",
            })
          )}`}
        />
      )}
      {orderStatus === "Contract" && (
        <PDFRenderer
          url={`${config.asset.uri}contract_changes/${btoa(
            JSON.stringify({
              offer_endorsement_id: searchParams?.id,
              doc_number: -1,
              type: "Contract",
              emp_id: currentUser?.employee?.employee_id || "",
            })
          )}`}
        />
      )}
    </Modal>
  );
}
